import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Button, Drawer, Modal, Select } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import {
  cashInOutReport,
  getCreditHistory,
  getPosOrderLines,
  posOrders,
} from "../../API  Functions/SessionHistoryFunctions";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import DateFilter from "../../components/ui/DateFilter";
import dayjs from "dayjs";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import i18next from "i18next";
import { toast } from "react-toastify";
import moment, { lang } from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import { AddBox } from "@mui/icons-material";
import { Plus } from "lucide-react";
import {
  getGroupProducts,
  getProductGroups,
} from "../../API  Functions/productGroupFunctions";
import VatTable from "../Setting/VatTable";

const VATSetup = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [vatName, setVatName] = useState("");
  const [vatPercentage, setVatPercentage] = useState("");
  const [mainLoading, setMainLoading] = useState(false);

  const [vatTypes, setVatTypes] = useState([]);
  const [createOpen, setCreateOpen] = useState(false);

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const [Loading, setLoading] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [drawerData, setDrawerData] = useState(null);
  const [orderLines, setOrderLines] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
const [addVatDrawerOpen, setAddVatDrawerOpen] = useState(false);

  useEffect(() => {
    GetVatTypes();
  }, [currentLimit, currentOffset]);

  const GetVatTypes = async () => {
    const payload = {
      retailer_id: company_id,
      offset: currentOffset,
      limit: currentLimit,
    };
    try {
      const res = await axiosInstance.post(URLS.GET_VAT_TYPES, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setVatTypes(res1?.result?.data);
      } else {
        setVatTypes([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  // const handleRowClick = async (order) => {
  //     setDrawerVisible(true);
  //     setDrawerLoading(true);
  //     setDrawerData(order);

  //     // console.log("vdfggv", order);

  //     try {
  //         const payload = {
  //             lang: i18n.language === "ar" ? "ar_001" : "en_US",
  //             company_id: company_id,
  //             user_id: user_id,
  //             group_id: order.id,
  //         };
  //         const res = await getGroupProducts(payload);

  //         // console.log("resresresres---->", res);

  //         if (res?.result[0]?.status_code === 200) {
  //             setOrderLines(res?.result[0]?.product_list || []);
  //         } else {
  //             setOrderLines([]);
  //         }
  //     } catch (error) {
  //         console.error("Error fetching order lines:", error);
  //     } finally {
  //         setDrawerLoading(false);
  //     }
  // };

  const onClose = () => {
    setDrawerVisible(false);
    setOrderLines([]);
  };

  const handleCreateVat = async () => {
    if (!vatName || !vatPercentage) {
      toast.error(t("Please fill all fields"));
      return;
    }

    try {
      setLoading(true);

      const payload = {
        retailer_id: company_id,
        tax_name: vatName,
        tax_rate_percent: vatPercentage,
        is_tax_price_inclusive: false,
      };

      const res = await axiosInstance.post(URLS.CREATE_VAT_TYPE, payload);
      const result = res?.data?.result;

      if (result?.status_code === 200) {
        toast.success(t("Tax type created successfully"));
        setCreateOpen(false);
        setVatName("");
        setVatPercentage("");
        GetVatTypes(); // refresh list if needed
      } else {
        toast.error(result?.status || t("Failed to create Tax type"));
      }
    } catch (error) {
      console.error(error);
      toast.error(t("Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (subStoreId, currentStatus) => {
    const newStatus = !currentStatus;
    setMainLoading(true);
    try {
      let payload = {
        retailer_id: company_id,
        tax_id: subStoreId,
        is_active: newStatus,
      };
      const res = await axiosInstance.post(URLS.UPDATE_VAT, payload);
   if(res?.data?.result?.status_code == 200){
    if(currentStatus){
    toast.success(t("Tax type disabled."))
    }else{
    toast.success(t("Tax type enabled."))
    }
    GetVatTypes();
   }
      // const result = res?.data?.result;

      // toast.success(t("Branch activated successfully"));
    } catch (error) {
      console.error(error);
      toast.error(t("Error toggling status"));
    } finally {
      setMainLoading(false);
    }
  };

  // console.log("Order Lines Response:", orderLines);

  return (
    <>
            {mainLoading && <LoadingSpinner />}

      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto ">
        {/* <Navbar heading="Tax" /> */}
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3 mt-2">
          <div className="font-extrabold mb-3"></div>

          <div className=" mt-3">
            <div className=" flex justify-end mt-3 mx-8">
              <button
                className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg mx-2 flex items-center justify-center gap-2"
                // onClick={() => setCreateOpen(true)}
                onClick={() => {
                  if (checkPermission("/settings/taxes", isGinne)) {
                    setCreateOpen(true);
                  }
                }}
              >
                <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} />

                <span>{t("Create Tax Type")}</span>
              </button>
            </div>

            {loading ? (
              <ShimmerLoader />
            ) : (
              <>
                <VatTable
                  additionalData={vatTypes}
                  pagination={(values) => {
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                  }}
                  onToggleStatus={handleToggleStatus}
                  // onRowClick={handleRowClick}
                  // onDelete={confirmDelete}
                  // onSaveEdit={(updatedRow) => {
                  //     handleEditSave(updatedRow);
                  // }}
                />
            
              </>
            )}
          </div>
        </div>
      </div>

      {/* Drawer */}
   <Drawer
  open={addVatDrawerOpen}
  onClose={() => setAddVatDrawerOpen(false)}
  placement="right"
  width={420}
  closable={false}
  bodyStyle={{ padding: 0 }}
>
  {/* Header */}
  <div className="flex items-center gap-3 px-6 py-4 border-b">
    <button
      onClick={() => setAddVatDrawerOpen(false)}
      className="text-lg font-bold"
    >
      ←
    </button>
    <h2 className="text-lg font-semibold">{t("Add Tax Type")}</h2>
  </div>

  {/* Content */}
  <div className="px-6 py-5 space-y-5">
    {/* Tax Name */}
    <div>
      <label className="block text-sm font-medium mb-1">
        {t("Tax Name")}
      </label>
      <input
        type="text"
        value={vatName}
        onChange={(e) => setVatName(e.target.value)}
        placeholder={t("Enter Tax name")}
        className="w-full h-10 px-3 border rounded-md focus:outline-none focus:ring-1 focus:ring-primaryBlue"
      />
    </div>

    {/* Tax Percentage */}
    <div>
      <label className="block text-sm font-medium mb-1">
        {t("Tax Percentage")}
      </label>

      <div className="relative">
        <input
          type="number"
          min={0}
          max={100}
          value={vatPercentage}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "") {
              setVatPercentage("");
              return;
            }
            const num = Number(value);
            if (num >= 0 && num <= 100) {
              setVatPercentage(num);
            }
          }}
          placeholder="0"
          className="w-full h-10 px-3 pr-10 border rounded-md focus:outline-none focus:ring-1 focus:ring-primaryBlue"
        />

        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
          %
        </span>
      </div>
    </div>
  </div>

  {/* Footer */}
  <div className="absolute bottom-0 left-0 right-0 px-6 py-4 border-t bg-white">
    <button
      onClick={handleCreateVat}
      disabled={loading}
      className="w-full h-11 rounded-lg bg-primaryBlue text-white font-semibold hover:opacity-90"
    >
      {loading ? t("Creating...") : t("Create Tax")}
    </button>
  </div>
</Drawer>


      {/* Confirmation Modal */}
      {/* <Modal
                open={showConfirmModal}
                onCancel={() => setShowConfirmModal(false)}
                footer={null}
                centered
                closable={false}
            >
                <div className="text-center p-6">
                    <h3 className="text-lg font-semibold mb-4 text-gray-800">
                        {t("Are you sure you want to delete this group ?")}
                    </h3>
                    <div className="flex justify-center gap-4 mt-6">
                        <button
                            onClick={() => setShowConfirmModal(false)}
                            className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
                        >
                            {t("No")}
                        </button>
                        <button
                            onClick={() => handleGroupDelete(selectedGroup)}  // ✅ fixed line
                            disabled={loading}
                            className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
                        >
                            {loading ? t("Removing...") : t("Yes")}
                        </button>
                    </div>
                </div>
            </Modal> */}

      <Modal
        open={createOpen}
        onCancel={() => setCreateOpen(false)}
        centered
        title={t("Create Tax Type")}
        footer={null}
      >
        <div className="space-y-4">
          {/* Tax Name */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Tax Name")}
            </label>
            <input
              type="text"
              value={vatName}
              onChange={(e) => setVatName(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none"
              placeholder={t("Enter Tax name")}
            />
          </div>

          {/* Tax Percentage */}
          <div>
            <label className="block text-sm font-medium mb-1">
              {t("Tax Percentage")}
            </label>
            <input
              type="number"
              min="0"
              max="100"
              value={vatPercentage}
              onChange={(e) => {
                const value = e.target.value;

                if (value === "") {
                  setVatPercentage("");
                  return;
                }

                const num = Number(value);

                if (num >= 0 && num <= 100) {
                  setVatPercentage(num);
                }
              }}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none"
              placeholder={t("Enter Tax percentage")}
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 pt-4">
            <button
              onClick={() => setCreateOpen(false)}
              className="px-4 py-2 rounded-lg border text-gray-600 hover:bg-gray-100"
            >
              {t("Cancel")}
            </button>

            <button
              onClick={handleCreateVat}
              disabled={loading}
              className="px-6 py-2 rounded-lg bg-primaryBlue text-white font-semibold hover:opacity-90"
            >
              {loading ? t("Creating...") : t("Create")}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default VATSetup;
